import { Component, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { IAbstractView } from '@core/interfaces';
import { SummaryPresenter } from './summary.presenter';
import { FormsModule } from '@angular/forms';
import { ButtonActionComponent } from '@shared/components/buttonAction/button-action.component';
import { IntegerToFloatPipe } from '@core/pipes/integer-to-float.pipe';
import { ISummaryComponent, ISummaryPresenter, PathValue } from './interfaces';
import { CartTotals, ClientPersonalInformationForm } from '@/core/models';
import { Observable } from 'rxjs';
import { InputComponent } from '@/shared/components';
import { LoadingComponent } from '@/shared/components/loading/loading.component';

@Component({
	selector: 'app-summary',
	templateUrl: './summary.component.html',
	styleUrls: ['./summary.component.scss'],
	imports: [IonicModule, CommonModule, FormsModule, ButtonActionComponent, IntegerToFloatPipe, InputComponent, LoadingComponent],
	providers: [SummaryPresenter],
	standalone: true,
})
export class SummaryComponent extends IAbstractView<ISummaryPresenter> implements ISummaryComponent {
	store$ = this.presenter.store$;
	serviceType$ = this.presenter.serviceType$;
	cartTotals$ = this.presenter.cartTotals$;
	showPromoInput = this.presenter.showPromoInput;
	promoCode = this.presenter.promoCode;
	appliedCoupon = this.presenter.appliedCoupon;
	currentSlug = this.presenter.currentSlug;
	loading$ = this.presenter.loading$;
	translations = this.presenter.translations;
	decimalPrecision = this.presenter.decimalPrecision;
	existProductOutStock = this.presenter.existProductOutStock;
	existDualPricing = this.presenter.existDualPricing;

	@Input() showSummary = this.presenter.showSummary;
	@Input() showTips = this.presenter.showTips;
	@Input() isCart = this.presenter.isCart;
	@Input() overrideCardContainer = this.presenter.overrideCardContainer;
	@Input() showUserSummary = this.presenter.showUserSummary;

	constructor(presenter: SummaryPresenter) {
		super(presenter);
	}

	handlePromoAction(): void {
		this.presenter.handlePromoAction();
	}

	togglePromoInput(): void {
		this.presenter.togglePromoInput();
	}

	onPromoCodeChange(value: string): void {
		this.presenter.onPromoCodeChange(value);
	}

	onProcedCheckout(): void {
		this.presenter.onProcedCheckout();
	}

	convertToUpperCase(event: Event): void {
		this.presenter.convertToUpperCase(event);
	}

	attributeClient<T extends keyof ClientPersonalInformationForm>(key: T): Observable<ClientPersonalInformationForm[T] | undefined> {
		return this.presenter.attributeClient(key);
	}

	attributeCartTotals<T extends keyof CartTotals>(key: T): Observable<PathValue<CartTotals, T> | undefined> {
		return this.presenter.attributeCartTotals(key);
	}

	paymentMethod(): Observable<string | null> {
		return this.presenter.paymentMethod();
	}
}
